import React, { useEffect, useState } from "react";
import { MdOutlineCloudDownload } from "react-icons/md";
import { toast } from "react-hot-toast";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import Layout from "../Layout";
import { Button, Select } from "../components/Form";
import { ServiceTable } from "../components/Tables";
import { servicesData, sortsDatas } from "../components/Datas";
import AddEditServiceModal from "../components/Modals/AddEditServiceModal";
import sericesApi from "../api/user/service.api";
import Loading from "../Util/Loading";
import { useSelector } from "react-redux";

function ServicesBeauty() {
  const user = useSelector((state) => state.user);
  // console.log({ user });
  const sortsDatas = {
    service: [
      { name: "Name (A-Z)", value: "name-asc" },
      { name: "Name (Z-A)", value: "name-desc" },
      { name: "Category (A-Z)", value: "category-asc" },
      { name: "Category (Z-A)", value: "category-desc" },
      { name: "Price (Low-High)", value: "price-asc" },
      { name: "Price (High-Low)", value: "price-desc" },
      { name: "Time (Short-Long)", value: "time-asc" },
      { name: "Time (Long-Short)", value: "time-desc" },
    ],
  };
  const [isOpen, setIsOpen] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [detail, setDetail] = React.useState();
  const [status, setStatus] = React.useState(sortsDatas.service[2]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStore, setSelectedStore] = useState("All");

  const operatorId = user?.user?._id;

  console.log({ operatorId });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getBeautyData()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const getBeautyData = async () => {
    try {
      const { response, err } = await sericesApi.getallBeauty({ operatorId });

      if (response && response.data) {
        setData(response.data.beautyservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getTimeInMinutes = (desc) => {
    const match = desc?.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  };

  // Apply sort based on selected status
  const filteredData = data.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.category.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStore =
      selectedStore === "All" ||
      (Array.isArray(item.operator) &&
        item.operator.some((op) => op.town === selectedStore));

    return matchesSearch && matchesStore;
  });

  const sortedData = filteredData.sort((a, b) => {
    switch (status.value) {
      case "name-asc":
        return a.title.localeCompare(b.title);
      case "name-desc":
        return b.title.localeCompare(a.title);
      case "category-asc":
        return a.category.localeCompare(b.category);
      case "category-desc":
        return b.category.localeCompare(a.category);
      case "price-asc":
        return a.price - b.price;
      case "price-desc":
        return b.price - a.price;
      case "time-asc":
        return getTimeInMinutes(a.desc) - getTimeInMinutes(b.desc);
      case "time-desc":
        return getTimeInMinutes(b.desc) - getTimeInMinutes(a.desc);
      default:
        return 0;
    }
  });

  const onCloseModal = () => {
    setIsOpen(false);
    setDetail({});
  };

  const onEdit = (datas) => {
    setIsOpen(true);
    setDetail(datas);
  };

  const handleSaveToBackend = async (payload) => {
    console.log({ payload });
    try {
      const res = await sericesApi.updateBeautyService(payload); // 👈 your PATCH API
      toast.success("Stores updated successfully!");
      await getBeautyData(); // refresh after save
    } catch (err) {
      toast.error("Failed to update stores");
      console.error("Update error:", err);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Layout>
      {isOpen && (
        <AddEditServiceModal
          title="Beauty Services"
          datas={detail}
          isOpen={isOpen}
          closeModal={onCloseModal}
        />
      )}
      {/* add button */}
      {/* <button
        onClick={() => setIsOpen(true)}
        className="w-16 animate-bounce h-16 border border-yellowlight z-50 bg-border text-yellowlight rounded-full flex-colo fixed bottom-8 right-12 button-fb"
      >
        <BiPlus className="text-2xl" />
      </button> */}
      {/*  */}
      <h1 className="text-xl font-semibold text-text">Beauty Services</h1>
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
        data-aos-offset="200"
        className="bg-main my-8 rounded-xl border-[1px] border-border p-5"
      >
        {/* datas */}

        <div className="grid md:grid-cols-6 grid-cols-1 gap-2">
          <div className="md:col-span-5 grid lg:grid-cols-4 xs:grid-cols-2 items-center gap-2">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search..."
              className="h-14 w-full text-sm text-text rounded-md bg-dry border border-border px-4"
            />
            <Select
              selectedPerson={status}
              setSelectedPerson={setStatus}
              datas={sortsDatas.service}
            >
              <div className="w-full flex-btn text-text text-sm p-4 border bg-dry border-border font-light rounded-lg focus:border focus:border-subMain">
                {status.name} <BiChevronDown className="text-xl" />
              </div>
            </Select>
            <select
              value={selectedStore}
              onChange={(e) => setSelectedStore(e.target.value)}
              className="h-14 w-full text-sm text-text rounded-md bg-dry border border-border px-4"
            >
              <option value="All">All Stores</option>
              <option value="Blenheim">Blenheim Only</option>
              <option value="Picton">Picton Only</option>
              <option value="Kaikoura">Kaikoura Only</option>
            </select>
          </div>

          {/* export */}
        </div>
        <div className="mt-8 w-full overflow-x-scroll">
          {sortedData.length === 0 ? (
            <p className="text-center text-sm text-subMain py-10">
              No services found.
            </p>
          ) : (
            <ServiceTable
              data={sortedData}
              onEdit={onEdit}
              onSave={handleSaveToBackend}
            />
          )}
        </div>
      </div>
    </Layout>
  );
}

export default ServicesBeauty;
